module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-72x72.png";